import { createRoot } from "react-dom/client";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { RegistrationForm } from "./registration/RegistrationForm";
import en from "./registration/locales/en.json";
import fi from "./registration/locales/fi.json";
import sv from "./registration/locales/sv.json";
import et from "./registration/locales/et.json";

const el = document.getElementById("registration-form");
const props = JSON.parse(el.dataset.props);

i18n.use(initReactI18next).init({
	lng: props.locale,
	fallbackLng: "en",
	resources: {
		en: { translation: en },
		fi: { translation: fi },
		sv: { translation: sv },
		et: { translation: et },
	},
	interpolation: { escapeValue: false },
});

createRoot(el).render(<RegistrationForm {...props} />);
